import GLightbox from "glightbox";
import "glightbox/dist/css/glightbox.min.css";

document.addEventListener("DOMContentLoaded", function () {
    const gallery = document.getElementById("product-media-gallery");
    if (!gallery) {
        return;
    }

    const mainImage = gallery.querySelector(".product-media__main-image");
    const mainVideo = gallery.querySelector(".product-media__main-video");
    const videoIframe = gallery.querySelector(".product-media__video-iframe");
    const thumbnails = gallery.querySelectorAll(".product-media__thumbnail");
    const prevBtn = gallery.querySelector(".product-media__nav--prev");
    const nextBtn = gallery.querySelector(".product-media__nav--next");

    // The mediaItems data needs to be passed from the Blade template.
    // We'll fetch it from a data attribute on the gallery element.
    const mediaItems = JSON.parse(gallery.dataset.mediaItems);
    let currentIndex = 0;

    // Helper function to convert YouTube URL to embed URL
    function getYouTubeEmbedUrl(url) {
        const youtubeId = extractYouTubeId(url);
        return youtubeId
            ? `https://www.youtube.com/embed/${youtubeId}?rel=0&modestbranding=1`
            : url;
    }

    // Helper function to convert Youku URL to embed URL
    function getYoukuEmbedUrl(url) {
        const youkuId = extractYoukuId(url);
        return youkuId
            ? `https://player.youku.com/embed/${youkuId}?autoplay=0&show_related=0`
            : url;
    }

    // Helper function to extract YouTube ID from URL
    function extractYouTubeId(url) {
        const match = url.match(
            /(?:youtube\.com\/watch\?v=|youtu\.be\/)([a-zA-Z0-9_-]+)/,
        );
        return match ? match[1] : null;
    }

    // Helper function to extract Youku ID from URL
    function extractYoukuId(url) {
        // Youku URLs can be in multiple formats:
        // https://v.youku.com/v_show/id_XNTA...==.html
        // https://player.youku.com/embed/XNTA...
        let match = url.match(
            /(?:v\.youku\.com\/v_show\/id_|player\.youku\.com\/embed\/)([a-zA-Z0-9_=]+)/,
        );
        if (!match) {
            // Try alternative pattern
            match = url.match(/youku\.com\/.*\/id_([a-zA-Z0-9_=]+)/);
        }
        const id = match ? match[1].replace(/\.html$/, "") : null;
        console.log("Youku URL:", url, "Extracted ID:", id);
        return id;
    }

    function updateMainMedia(index) {
        const media = mediaItems[index];
        currentIndex = index;

        if (media.type === "image") {
            mainImage.src = media.src;
            mainImage.alt = media.alt;
            mainImage.style.display = "block";
            mainVideo.style.display = "none";
            // Reset video iframe when hiding
            if (videoIframe) {
                videoIframe.src = "";
            }
        } else if (media.type === "video") {
            // Handle YouTube or Youku videos
            let embedUrl;
            if (media.is_youku) {
                embedUrl = getYoukuEmbedUrl(media.src);
            } else {
                embedUrl = getYouTubeEmbedUrl(media.src);
            }
            videoIframe.src = embedUrl;
            mainImage.style.display = "none";
            mainVideo.style.display = "block";
        }

        thumbnails.forEach((thumb, i) => {
            thumb.classList.toggle(
                "product-media__thumbnail--active",
                i === index,
            );
        });
    }

    thumbnails.forEach((thumbnail, index) => {
        thumbnail.addEventListener("click", () => {
            updateMainMedia(index);
        });
    });

    if (prevBtn && nextBtn) {
        prevBtn.addEventListener("click", () => {
            let newIndex = currentIndex - 1;
            if (newIndex < 0) {
                newIndex = mediaItems.length - 1; // Loop to the last item
            }
            updateMainMedia(newIndex);
        });

        nextBtn.addEventListener("click", () => {
            let newIndex = currentIndex + 1;
            if (newIndex >= mediaItems.length) {
                newIndex = 0; // Loop to the first item
            }
            updateMainMedia(newIndex);
        });
    }

    document.addEventListener("keydown", (e) => {
        if (e.key === "ArrowLeft") {
            let newIndex = currentIndex - 1;
            if (newIndex < 0) {
                newIndex = mediaItems.length - 1;
            }
            updateMainMedia(newIndex);
        } else if (e.key === "ArrowRight") {
            let newIndex = currentIndex + 1;
            if (newIndex >= mediaItems.length) {
                newIndex = 0;
            }
            updateMainMedia(newIndex);
        }
    });

    updateMainMedia(0);

    // Créer GLightbox avec tous les médias (images et vidéos YouTube)
    const lightbox = GLightbox({
        elements: mediaItems.map((item) => {
            if (item.type === "image") {
                return {
                    href: item.src,
                    type: "image",
                };
            } else if (item.type === "video") {
                // Pour les vidéos YouTube ou Youku, utiliser l'URL d'embed appropriée
                if (item.is_youku) {
                    const embedUrl = getYoukuEmbedUrl(item.src);
                    // Pour Youku, créer un contenu HTML personnalisé avec ratio 16:9
                    return {
                        content: `<div class="glightbox-youku-container">
                            <div class="glightbox-youku-wrapper">
                                <iframe
                                    src="${embedUrl}"
                                    frameborder="0"
                                    allowfullscreen
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture">
                                </iframe>
                            </div>
                        </div>`,
                    };
                } else {
                    const embedUrl = getYouTubeEmbedUrl(item.src);
                    return {
                        href: embedUrl,
                        type: "video",
                        source: "youtube",
                        width: "90vw",
                        height: "80vh",
                    };
                }
            }
        }),
        touchNavigation: true,
        loop: true,
        autoplayVideos: false,
        onOpen: () => {
            // Remove focus from main element when lightbox opens
            const mainElement = document.getElementById("main");
            if (mainElement) {
                mainElement.blur();
                // Remove tabindex to prevent focus retention
                mainElement.removeAttribute("tabindex");
            }
        },
        onClose: () => {
            // Restore tabindex when lightbox closes
            const mainElement = document.getElementById("main");
            if (mainElement) {
                mainElement.setAttribute("tabindex", "-1");
            }
        },
    });

    const mainMediaContainer = gallery.querySelector(".product-media__main");
    mainMediaContainer.addEventListener("click", (event) => {
        // Prevent lightbox from opening if a nav button was clicked
        if (event.target.closest(".product-media__nav")) {
            return;
        }

        // Ouvrir le lightbox à l'index actuel (fonctionne pour images et vidéos)
        lightbox.openAt(currentIndex);
    });
});
